<template>
  <LinkCss  :href="getWithHost(tailwindCss)" v-model:on-load-end="show" />
  <body v-if="show" data-theme="light">
    <CategoryCarouselVue
      :props="propsParsed"
    ></CategoryCarouselVue>
  </body>
</template>
<script lang="ts" setup>
import LinkCss from "@/components/LinkCss.vue"
import tailwindCss from '@/styles/style.css?url'
import { ref } from 'vue'
import { getWithHost } from '@/utils/utils'
import CategoryCarouselVue from '@/components/CategoryCarousel.vue'


const props = defineProps<{
  props: string
}>()

const propsParsed = JSON.parse(props.props)

const show = ref(false)
</script>
